"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgShoppingCartFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30.23 7H6.82l-.34-1.69a3.74 3.74 0 00-1.4-2.54A4.13 4.13 0 002.49 2H1v2h1.48a2.3 2.3 0 011.38.36c.25.19.46.35.66 1.35l3 15a3.74 3.74 0 001.4 2.54 4.13 4.13 0 002.59.77H27V22H11.52a2.3 2.3 0 01-1.38-.36c-.25-.19-.46-.35-.66-1.35L9 18h18.94z" }),
        React.createElement("circle", { cx: 11, cy: 28, r: 2, transform: "rotate(-9.22 10.976 27.972)" }),
        React.createElement("circle", { cx: 25, cy: 28, r: 2 })));
}
exports.default = SvgShoppingCartFilled;
//# sourceMappingURL=ShoppingCartFilled.js.map